import { useMemo } from "react";
import { ConnectProto } from "@racoon/api";
import { useGetOrganizationSettingsQuery } from "~/shared/api/organization/organization.grpc";
import { useAuthSession } from "~/shared/hooks/auth.session.admin";
import { JOB_TYPE_CATEGORY_KEY } from "~/shared/lib/translationMaps";

/** Disabled types as a set, plus the categories ("CATEGORY_CO", …) with no enabled type left. */
export function summarizeDisabledJobTypes(disabledList: readonly ConnectProto.JobType[] = []) {
  const types = new Set<ConnectProto.JobType>(disabledList);
  const typesByCategory = new Map<string, ConnectProto.JobType[]>();
  for (const [type, category] of Object.entries(JOB_TYPE_CATEGORY_KEY)) {
    if (!category) continue;
    typesByCategory.set(category, [...(typesByCategory.get(category) ?? []), Number(type)]);
  }
  const categories = new Set(
    [...typesByCategory]
      .filter(([, inCategory]) => inCategory.every((type) => types.has(type)))
      .map(([category]) => category),
  );
  return { types, categories };
}

/**
 * Job types the current organization turned off in Настройки → Типы работ. Nothing is
 * hidden for an admin inside another company: GetSetting only knows the caller's own org.
 */
export function useDisabledJobTypes() {
  const { activeCompanyId } = useAuthSession();
  const { data } = useGetOrganizationSettingsQuery({});
  const isOwnOrg = !data || !activeCompanyId || Number(data.id) === activeCompanyId;
  const disabledList = isOwnOrg ? data?.disabledJobTypes?.types : undefined;
  return useMemo(() => summarizeDisabledJobTypes(disabledList), [disabledList]);
}
